import { useContext } from "react";

import { AccountContext } from "./AccountContext";

export const useCurrentAccount = () => {
  const { getAccount } = useContext(AccountContext);
  return { getAccount };
};
